import React from 'react';
import styled from 'styled-components';

import { colors } from '@/constants/theme';

interface Props {
  percent?: number;
  className?: string;
}

function Progress({ percent, className }: Props) {
  return (
    <Component className={className}>
      <ProgressBar percent={percent} />
    </Component>
  );
}

export default Progress;

const Component = styled.div`
  display: flex;
  height: 8px;
  overflow: hidden;
  font-size: 0.75rem;
  background-color: #e1e1e1;
  border-radius: 0.25rem;
`;

const ProgressBar = styled.div<{ percent?: number }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: ${colors.white};
  text-align: center;
  white-space: nowrap;
  background-color: ${colors.main};
  border-radius: 0.25rem;
  transition: width 0.6s ease;

  width: ${({ percent }) => (percent ? `${percent}%` : 0)};

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;
